import { Modal as BasicModal } from '../basics';
import { Button } from 'antd';
import classnames from 'classnames';

import styles from './modal.module.scss';

import type { FC, ReactNode } from 'react';
import type { ModalProps as BasicModalProps } from '../basics';

export interface ModalProps extends BasicModalProps {

  /**
  * @description 标题
  */
  title?: ReactNode;

  /**
  * @description 底部内容，当不需要默认底部按钮时，可以设为 footer={null}	
  */
  footer?: ReactNode;

  /**
  * @description 确认按钮文字	
  */
  onOkText?: ReactNode;

  /**
  * @description 取消按钮文字	
  */
  onCancelText?: ReactNode;

  /**
  * @description 点击确定回调	
  */
  onOk?: (e: React.SyntheticEvent) => void;

}

const Modal: FC<ModalProps> = (props) => {

  const prefixCls = 'web_components_modal';
  const {
    title,
    footer,
    children,
    className,
    onCancelText,
    onOkText,
    onOk,
    onCancel,
    ...restModalProps
  } = props;

  const handleCancel = (e: React.SyntheticEvent) => {
    onCancel && onCancel(e);
  }

  const handleOk = (e: React.SyntheticEvent) => {
    onOk && onOk(e);
    onCancel && onCancel(e);
  }

  const renderFooter = () => {

    if (footer) {
      return footer;
    }

    return (
      <>
        <Button
          type='primary'
          ghost
          className={`${prefixCls}_footer_button_cancel`}
          onClick={handleCancel}
        >
          {onCancelText || 'Cancel'}
        </Button>
        <Button
          type='primary'
          className={`${prefixCls}_footer_button_ok`}
          onClick={handleOk}
        >
          {onOkText || 'OK'}
        </Button>
      </>
    )
  }

  return (
    <BasicModal
      {...restModalProps}
      onCancel={onCancel}
      className={classnames(className, styles.web_components_modal_common)}
    >
      {title && (
        <div
          className={`${prefixCls}_header`}>
          {title}
        </div>
      )}
      <div
        className={`${prefixCls}_body`}>
        {children}
      </div>
      {
        footer !== null && (
          <div className={classnames(`${prefixCls}_footer`, { [`${prefixCls}_base_footer`]: !footer })}>
            {renderFooter()}
          </div>
        )
      }
    </BasicModal>
  )
}

export default Modal;